import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import {
useGetGameQuery, useCreateGameUnitMutation
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
IGame, IGameUnit
} from "../../../Api/Interface/api.interface";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";

import { styled, useTheme } from "@mui/material/styles";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";


interface IProductPopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IGameUnit;
}

const ProductPopUP = ({
  openModel = false,
  handleCloseDialog,
  data,
}: IProductPopup) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open] = React.useState(openModel);
  const [newLocation, { isLoading }] = useCreateGameUnitMutation();
   const { data: gamesData } = useGetGameQuery({ searchText: ""});
   const { showErrorMessage, showMessage } = useNotifier();
 
   const games: IGame[] = Array.isArray(gamesData?.data)
           ? (gamesData?.data as IGame[])
           : [];
   
   const handleClose = () => {
     handleCloseDialog(false);
   };
 
   const formik = useFormik({
   initialValues: {
     id: data?.id ,
     game_id: data?.game?.id || "",
     name: data?.name ?? "",
     capacity: data?.capacity ?? "",
     position_group: data?.position_group ?? "",
     entry_offset_minutes: data?.entry_offset_minutes ?? "",

    display_name: data?.display_name || "",
    short_description: data?.short_description || "",
    description: data?.description || "",
    pricing_type: data?.pricing_type || "",
    min_kids: data?.min_kids ?? "",      
    max_kids: data?.max_kids ?? "",
    min_adults: data?.min_adults ?? "",
    max_adults: data?.max_adults ?? "",
    free_kids_included: data?.free_kids_included ?? "",
    free_adults_included: data?.free_adults_included ?? "",
    extra_kids_allowed: data?.extra_kids_allowed ?? false,
    extra_adults_allowed: data?.extra_adults_allowed ?? false,
    kid_price: data?.kid_price ?? "",
    adult_price: data?.adult_price ?? "",
    extra_kid_price: data?.extra_kid_price ?? "",
    extra_adult_price: data?.extra_adult_price ?? "",
    shared_capacity: data?.shared_capacity ?? "",
    max_date_changes: data?.max_date_changes ?? "",
    refund_after_changes: data?.refund_after_changes ?? false,

     isActive: data?.isActive ? Boolean(data?.isActive) : false,
     },
     onSubmit: async (values) => {
       try {
        
          const temData = {
      id: values?.id,
     game_id: Number(values.game_id),
     name: values.name,
     capacity: values.capacity ? Number(values.capacity) : 0,
     position_group: values.position_group || null,
     entry_offset_minutes: values.entry_offset_minutes
           ? Number(values.entry_offset_minutes)
           : 0,

display_name: values.display_name,
  short_description: values.short_description,
  description: values.description,
  pricing_type: values.pricing_type,
  min_kids: Number(values.min_kids) || 0,
  max_kids: Number(values.max_kids) || 0,
  min_adults: Number(values.min_adults) || 0,
  max_adults: Number(values.max_adults) || 0,
  free_kids_included: Number(values.free_kids_included) || 0,
  free_adults_included: Number(values.free_adults_included) || 0,
  extra_kids_allowed: Boolean(values.extra_kids_allowed),
  extra_adults_allowed: Boolean(values.extra_adults_allowed),
  kid_price: Number(values.kid_price) || 0.0,
  adult_price: Number(values.adult_price) || 0.0,
  extra_kid_price: Number(values.extra_kid_price) || 0.0,
  extra_adult_price: Number(values.extra_adult_price) || 0.0,
  shared_capacity: values.shared_capacity ? Number(values.shared_capacity) : null,
  max_date_changes: Number(values.max_date_changes) || 0,
  refund_after_changes: Boolean(values.refund_after_changes),

   isActive: values.isActive,
 };
     
         if (!data) {
           delete values.id;
         }
 
         const addCompanyResponse = await newLocation(temData).unwrap();
         if (!addCompanyResponse.status) {
           showErrorMessage(addCompanyResponse.message);
         } else {
           showMessage(addCompanyResponse.message);
           handleClose();
          // console.log((addCompanyResponse.data as IGame).id);
         }
       } catch (error) {
         showErrorMessage("Something went wrong");
       }
     },
   });
 
 
     const formValid = useMemo(() => {
         return formik.values.name === "" ||
           formik.values.name === undefined
           ? false
           : true;
       }, [formik]);
     
 

    

  return (
    <Dialog
      open={open}
        fullWidth
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
        <Grid container spacing={3}>
         
          <Grid item lg={12} md={12} sm={12} xs={12}>
      
               <form onSubmit={formik.handleSubmit}>
                       <Grid container>
                         <Grid item lg={12} md={12} sm={12} xs={12}>
                           <Card className={classes.card}>
                             <Grid
                               container
                               justifyContent={"space-between"}
                               spacing={5}
                               sx={{ borderBottom: 2, padding: 2 }}
                               className={classes.titleGrid}
                             >
                               <Grid
                                 item
                                 lg={12}
                                 md={12}
                                 sm={12}
                                 xs={12}
                                 pt={2}
                                 alignContent={"center"}
                               >
                                 <Typography className={classes.cardTitle}>
                                   Game Unit Information
                                 </Typography>
                               </Grid>
                             </Grid>
           
                             <Grid container spacing={3} p={"24px"}>
                               {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                 <Grid container alignItems="center">
           
           
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Typography variant="subtitle1">
                                        Game <span style={{ color: "red" }}>*</span>
                                     </Typography>
                                   </Grid>
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <TextField
                                   select
                                   fullWidth
                                   size="small"
                                   {...formik.getFieldProps("game_id")}
                                   className={classes.textField}
                                 >
                                   <MenuItem value="">Select Game</MenuItem>
                                   {games?.map((game: IGame) => (
                                     <MenuItem key={game.id} value={game.id}>
                                       {game.name}
                                     </MenuItem>
                                   ))}
                                 </TextField>
                                   </Grid>
                                 </Grid>
                               </Grid> */}
           
           
           
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Typography variant="subtitle1">
                                        Name <span style={{ color: "red" }}>*</span>
                                     </Typography>
                                   </Grid>
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <TextField
                                       placeholder="Enter Name"
                                       size="small"
                                       {...formik.getFieldProps("name")}
                                       className={classes.textField}
                                       InputProps={{
                                         sx: {
                                           fontSize: 14,
                                         },
                                       }}
                                       InputLabelProps={{
                                         sx: {
                                           fontSize: 14,
                                         },
                                       }}
                                     />
                                   </Grid>
                                 </Grid>
                               </Grid>
           
                              
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Capacity</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   type="number"
                   size="small"
                   {...formik.getFieldProps("capacity")}
                   className={classes.textField}
                 />
               </Grid>
             </Grid>
           </Grid>
           
           {/* <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Position Group</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   size="small"
                   {...formik.getFieldProps("position_group")}
                   className={classes.textField}
                 />
               </Grid>
             </Grid>
           </Grid> */}
           
           
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Entry Offset (Minutes)</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   type="number"
                   placeholder="Entry Offset (Minutes)"
                   size="small"
                   {...formik.getFieldProps("entry_offset_minutes")}
                   className={classes.textField}
                   inputProps={{ min: "0" }}
                 />
               </Grid>
             </Grid>
           </Grid>
             <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Display Name</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   placeholder="Enter Display Name"
                   size="small"
                   {...formik.getFieldProps("display_name")}
                   className={classes.textField}
                 />
               </Grid>
             </Grid>
           </Grid>
           
           <Grid item lg={12} md={12} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Short Description</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   placeholder="Enter Short Description"
                   size="small"
                   multiline
                   rows={2}
                   {...formik.getFieldProps("short_description")}
                   className={classes.discriptionTextField}
                 />
               </Grid>
             </Grid>
           </Grid>
           
           <Grid item lg={12} md={12} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Description</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   placeholder="Enter Description"
                   size="small"
                   multiline
                   rows={4}
                   {...formik.getFieldProps("description")}
                   className={classes.discriptionTextField}
                 />
               </Grid>
             </Grid>
           </Grid>
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Pricing Type <span style={{ color: "red" }}>*</span></Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   select
                   fullWidth
                   size="small"
                   value={formik.values.pricing_type}
                   onChange={(e) => formik.setFieldValue("pricing_type", e.target.value)}
                 >
                   <MenuItem value="">Select Type</MenuItem>
                   <MenuItem value="per_person">Per Person</MenuItem>
                   <MenuItem value="per_unit">Per Unit</MenuItem>
                   <MenuItem value="fixed">Fixed</MenuItem>
                 </TextField>
               </Grid>
             </Grid>
           </Grid>
           
           {/* <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Shared Capacity</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   type="number"
                   placeholder="Shared Capacity"
                   size="small"
                   {...formik.getFieldProps("shared_capacity")}
                   className={classes.textField}
                   inputProps={{ min: "0" }}
                 />
               </Grid>
             </Grid>
           </Grid> */}
           
           
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Max Date Changes</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   type="number"
                   size="small"
                   {...formik.getFieldProps("max_date_changes")}
                   className={classes.textField}
                 />
               </Grid>
             </Grid>
           </Grid>
                      
           
                               <Grid item lg={6} md={6} sm={12} xs={12}>
                                 <Grid container alignItems="center">
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Typography variant="subtitle1">Active</Typography>
                                   </Grid>
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <CustomSwitch
                                       color="primary"
                                       sx={{ mr: 2 }}
                                       formik={formik}
                                       name="isActive"
                                     />
                                   </Grid>
                                 </Grid>
                               </Grid>
           
           
           
           
           
                             </Grid>
                           </Card>
                         </Grid>




<Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                        Kids Information
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                    

                  
<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Min Kids</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("min_kids")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Max Kids</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("max_kids")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Free Kids Included</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("free_kids_included")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Kids Allowed</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <CustomSwitch
        formik={formik}
        name="extra_kids_allowed"
        color="primary"
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Kid Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("kid_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Kid Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("extra_kid_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

           



                     
                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                        Adults Information
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                    

                  
<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Min Adults</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("min_adults")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Max Adults</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("max_adults")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>
                      


<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Free Adults Included</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("free_adults_included")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Adults Allowed</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <CustomSwitch
        formik={formik}
        name="extra_adults_allowed"
        color="primary"
      />
    </Grid>
  </Grid>
</Grid>


<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Adult Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("adult_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>


<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Adult Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("extra_adult_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>


           
           
           
                             </Grid>
                           </Card>
                         </Grid>

           
                         <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                           <Card className={classes.card}>
                             <Grid container spacing={3} p={"24px"}>
                               <Grid
                                 item
                                 lg={12}
                                 md={12}
                                 sm={12}
                                 xs={12}
                                 sx={{ display: "flex", justifyContent: "flex-end" }}
                               >
                                 <Button
                                   variant="outlined"
                                   startIcon={<CloseIcon />}
                                   className={classes.addButton}
                                   onClick={() => handleCloseDialog(false)}
                                 >
                                   Cancel
                                 </Button>
                                 <Box m={0.5}></Box>
           
                                 <Button
                                   variant="contained"
                                   startIcon={<SaveAltIcon />}
                                   className={classes.addButton}
                                   onClick={() => formik.handleSubmit()}
                                   disabled={!formValid || isLoading}
                                 >
                                   Save
                                 </Button>
                               </Grid>
                             </Grid>
                           </Card>
                         </Grid>
                       </Grid>
                     </form>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ProductPopUP;
